import { render } from "./as-block-component.vue?vue&type=template&id=b578f006&scoped=true&ts=true"
import script from "./as-block-component.vue?vue&type=script&lang=ts"
export * from "./as-block-component.vue?vue&type=script&lang=ts"

import "./as-block-component.vue?vue&type=style&index=0&id=b578f006&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b578f006"]])

export default __exports__